function headerTopButton(){
    if(document.querySelector('.header__desktop-top') && !window.isMobile){
        showHeaderBtn();
        headerTopBg();
        document.addEventListener("scroll", () => {
            showHeaderBtn();
            headerTopBg();
        });
        function showHeaderBtn(){
            const headerTopBtn = document.querySelector('.header__top-button');
            const headerBtn = document.querySelector('.header__button');
            const headerTopHeight = document.querySelector('.header__desktop-top').clientHeight;
            if(headerTopBtn){
                if(headerBtn.getBoundingClientRect().top - headerTopHeight <= 0){
                    headerTopBtn.classList.add('header__top-button_active');
                } else {
                    headerTopBtn.classList.remove('header__top-button_active');
                }
            }
        }

        function headerTopBg(){
            if(window.scrollY == 0){
                document.querySelector('.header__desktop-top').classList.add('header__desktop-top_bg-transparent');
            } else {
                document.querySelector('.header__desktop-top').classList.remove('header__desktop-top_bg-transparent');
            }
        }
    }
}

export default headerTopButton;